import GetTerminalInformationComponent from '../Pages/TerminalManagement/GetTerminalInformation';
import GetTerminalPackagesComponent from '../Pages/TerminalManagement/GetTerminalPackages';
import TerminalCreateAndUpdateComponent from '../Pages/TerminalManagement/TerminalCreateAndUpdate';

const AccessV2TerminalManagementComponent = () => {

    return (
        <article className="docs-article" id="section-5">

            <header className="docs-header">
                <h1 className="docs-heading">Terminal Management<span className="docs-time">Last updated: 2023-11-28</span>
                </h1>
                <section className="docs-intro">
                    <p></p>
                    <br />
                    <div className="docs-intro-section">
                        <h3></h3>
                        <br />
                        <br />
                    </div>
                </section>
            </header>

            <GetTerminalInformationComponent />
            <GetTerminalPackagesComponent />
            <TerminalCreateAndUpdateComponent />

        </article>
    )
}

export default AccessV2TerminalManagementComponent;